export default function(x) {
  var r = Math.exp(x);
  r = (r - 1 / r) / 2;
  return r;
}


//////////////////
// WEBPACK FOOTER
// ./~/proj4/lib/common/sinh.js
// module id = Zl3z
// module chunks = 0